import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class ReferenceDataAPI {
  static getGridData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.RetrieveScreenInfo,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }

  static saveData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.ExecuteScreenAction,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static updateData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.ExecuteScreenAction,
      'PUT',
      AppConstants.APP_BACKEND_HOST_KEY, //undo this and use method callAzureFunction while checking in
      data
    );
  }

  static addComment(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.AddComment,
      'PUT',
      AppConstants.APP_BACKEND_HOST_KEY, //undo this and use method callAzureFunction while checking in
      data
    );
  }

  static deleteData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.ExecuteScreenAction,
      'DELETE',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
